export const froalaConfig = {
  key: 'hWA2C-7F2C6C4A3D4D2vd1EAJLQCVLUVBa1NXNRSSATEXD-13C3B2E2F2E3B1C6C7D2D2==',
  attribution: false,
  toolbarButtons: {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'fontFamily',
        'fontSize',
        'textColor',
        'backgroundColor',
        'clearFormatting',
      ],
    },

    moreParagraph: {
      buttons: [
        'alignLeft',
        'alignCenter',
        'formatOLSimple',
        'alignRight',
        'alignJustify',
        'formatOL',
        'formatUL',
        'paragraphFormat',
        'paragraphStyle',
        'lineHeight',
        'outdent',
        'indent',
        'quote',
      ],
    },
    moreRich: {
      buttons: [
        'insertLink',
        'insertImage',
        'insertVideo',
        'insertTable',
        'emoticons',
        'fontAwesome',
        'specialCharacters',
        'embedly',
        'insertFile',
        'insertHR',
      ],
    },
    moreMisc: {
      buttons: [
        'undo',
        'redo',
        'fullscreen',
        'print',
        'getPDF',
        'spellChecker',
        'selectAll',
        'html',
        'help',
      ],
      align: 'right',
      buttonsVisible: 2,
    },
  },
  toolbarButtonsSM: {
    moreText: {
      buttons: ['bold', 'italic', 'underline'],
    },

    moreParagraph: {
      buttons: ['alignLeft', 'alignCenter'],
    },
    moreRich: {
      buttons: [
        'insertLink',
        'emoticons',
        'fontAwesome',
        'specialCharacters',
        'insertHR',
      ],
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'fullscreen'],
      align: 'right',
      buttonsVisible: 2,
    },
  },
};
